import {createAction, createSlice} from '@reduxjs/toolkit';
import {ADS_SLICE_NAME} from '@jobseeker/common-core/constants';
import {HYDRATE} from 'next-redux-wrapper';

import type {AppState, AdsState} from '@jobseeker/common-core/types';

const initialState: AdsState = {
  featureEmployer: [
    {
      imageUrl: '',
      companyLogo: '',
      title: '',
      link: '',
    },
  ],
  enhanceSkills: [
    {
      title: '',
      imageUrl: '',
      link: '',
    },
  ],
  companyWorkWith: [
    {
      title: '',
      imageUrl: '',
      link: '',
    },
  ],
  learningPartners: [
    {
      title: '',
      imageUrl: '',
      link: '',
    },
  ],
  diversity: [
    {
      title: '',
      imageUrl: '',
      link: '',
    },
  ],
  advertisementBanner: [
    {
      title: '',
      imageUrl: '',
      link: '',
    },
  ],
  learnGrow: [
    {
      title: '',
      imageUrl: '',
      link: '',
    },
  ],
  featuredInstitues: [
    {
      title: '',
      imageUrl: '',
      link: '',
    },
  ],
  platinumPartners: [],
  goldPartners: [],
  blogs: [],

  events: [
    {
      title: '',
      imageUrl: '',
      link: '',
    },
  ],
  wow: [],
};

const HyDrate = createAction<AppState>(HYDRATE);

const adsSlice = createSlice({
  name: ADS_SLICE_NAME,
  initialState,
  reducers: {
    set_featured_employer: (state, action) => {
      state.featureEmployer = action.payload;
    },
    set_company_work_with: (state, action) => {
      state.companyWorkWith = action.payload;
    },
    set_enhance_skills: (state, action) => {
      state.enhanceSkills = action.payload;
    },
    set_learning_partner: (state, action) => {
      state.learningPartners = action.payload;
    },
    set_diversity: (state, action) => {
      state.diversity = action.payload;
    },
    set_learn_grow: (state, action) => {
      state.learnGrow = action.payload;
    },
    set_featured_institutes: (state, action) => {
      state.featuredInstitues = action.payload;
    },
    set_events: (state, action) => {
      state.events = action.payload;
    },
    set_ad_banner: (state, action) => {
      state.advertisementBanner = action.payload;
    },
    set_blog_data: (state, action) => {
      state.blogs = action.payload;
    },
  },
  extraReducers(builder) {
    builder.addCase(HyDrate, (state, action) => {
      if (!action.payload.ads) {
        return state;
      }

      state.featureEmployer = action.payload?.ads?.featureEmployer;
      state.companyWorkWith = action.payload?.ads?.companyWorkWith;
      state.enhanceSkills = action.payload?.ads?.enhanceSkills;
      state.learningPartners = action.payload?.ads?.learningPartners;
      state.diversity = action.payload?.ads?.diversity;
      state.learnGrow = action.payload?.ads?.learnGrow;
      state.featuredInstitues = action.payload?.ads?.featuredInstitues;
      state.platinumPartners = action.payload?.ads?.platinumPartners;
      state.goldPartners = action.payload?.ads?.goldPartners;
      state.events = action.payload?.ads?.events;
      state.blogs = action.payload?.ads?.blogs
    });
  },
});

export const {
  set_featured_employer,
  set_company_work_with,
  set_enhance_skills,
  set_learning_partner,
  set_diversity,
  set_learn_grow,
  set_featured_institutes,
  set_events,
} = adsSlice.actions;

export const selectAdsState = (state: AppState) => state.ads;

const reducer = adsSlice.reducer;

export {reducer, initialState};
